import styled from "styled-components";

export const Style = styled.div`
  h2,
  h3,
  span {
    color: #fff !important;
    line-height: 150% !important;
  }
  h2,
  h3 {
    font-weight: 500 !important;
  }

  h2 {
    font-size: 24px !important;
  }
  h3 {
    font-size: 18px !important;
  }
  span {
    font-size: 10px !important;
    font-weight: 600 !important;
  }

  .titleWrap {
    position: absolute;
    width: 100%;
    top: 10%;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    h1 {
      font-size: 50px;
      line-height: 140%;
      font-weight: 400;
      font-family: "Jalnan2TTF";
    }
    h1.mini {
      font-size: 38px;
      line-height: 70px;
      letter-spacing: -3px;
    }
    h2.title {
      font-weight: 700 !important;
      padding-bottom: 10px;
    }
  }

  .imageBox {
    position: relative;
  }
  .imageBox:after {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0) 100%);
  }
  .adImg {
    position: relative;
    object-fit: cover !important;
  }

  .storebuttonWrap {
    position: absolute;
    bottom: 30px;
    right: 36px;
    z-index: 1;
    display: flex;
    flex-direction: column;
    gap: 12px;

    .storeButton {
      display: flex;
      color: #fff;
      font-weight: 500;
      border-radius: 15px;
      overflow: hidden;

      .orderCountWrap {
        background-color: #000000cc;
        text-align: center;
        padding: 7px 10px;
      }
      .storeNameWrap {
        width: 40vw;
        background-color: #00000099;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 11px 8px 11px 18px;
        h2 {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      img {
        width: 32px;
        height: 32px;
      }
    }
  }
`;
